// extracted by mini-css-extract-plugin
export default {"wrapper":"NotFound_wrapper__FnV4u","errorCode":"NotFound_errorCode__Y8wDa","title":"NotFound_title__EkEgc","message":"NotFound_message__f39f0","btn":"NotFound_btn__MPqK+"};